// extracted by mini-css-extract-plugin
export var container = "_3-0";
export var formArea = "_3-5";
export var formWrapper = "_3-4";
export var fullWidthButton = "_3-6";
export var leftPanel = "_3-1";
export var loadingSpinner = "_3-8";
export var logo = "_3-3";
export var logoLockup = "_3-2";
export var primaryActionButton = "_3-7";
export var spin = "_3-9";